import React from 'react';
import PropTypes from 'prop-types';
import { Spacer } from '@tfecom-thermofisher/react-komodo-design';

import SectionTitle from 'src/components/SectionTitle';
import {
  PLATE_SIZE_FIELD,
  WELL_FIELD,
  SCALE_FIELD,
  PURIFICATION_FIELD,
  BUFFER_FIELD,
  SHIPPING_FORMAT_FIELD,
  QUALITY_TESTING_FIELD,
  COUNTRY_CODE_JAPAN,
  SECOND_PRIORITY_COUNTRIES
} from 'src/constants/forms';
import withDnaData from 'src/components/OligoDNA/components/withDnaData';
import DataSelector from 'src/components/DataSelector';
import { Visible } from 'src/core/components';
import { getCountryCode } from 'src/utils';

import {
  PLATE_SIZE_LINK,
  PURIFICATION_LINK,
  BUFFER_LINK,
  SCALE_LINK,
} from './constants';
import messages from './messages';

const PlateSizeAndDetailsComponent = ({
  formData,
  onChangeData,
  plateSizeConfig,
  wellVolumeConfig,
  scaleConfig,
  purificationConfig,
  bufferConfig,
  qualityTestingConfig,
  shippingFormatConfig
}) => (
  <div>
    <SectionTitle title={messages.customizeOrder} allFieldsRequired />
    <Spacer bottom={24} />
    <DataSelector
      {...{
        title: messages.plateSize,
        config: plateSizeConfig,
        selectedValue: formData[PLATE_SIZE_FIELD]?.value,
        onSelect: (value) => onChangeData(value, PLATE_SIZE_FIELD, true),
        moreInfoLink: PLATE_SIZE_LINK,
      }}
    />
    <DataSelector
      {...{
        title: messages.well,
        config: wellVolumeConfig,
        selectedValue: formData[WELL_FIELD]?.value,
        onSelect: (value) => onChangeData(value, WELL_FIELD, true),
      }}
    />
    <DataSelector
      {...{
        title: messages.scale,
        config: scaleConfig,
        selectedValue: formData[SCALE_FIELD]?.value,
        onSelect: (value) => onChangeData(value, SCALE_FIELD, true),
        moreInfoLink: SCALE_LINK,
      }}
    />
    <DataSelector
      {...{
        title: messages.purification,
        config: purificationConfig,
        selectedValue: formData[PURIFICATION_FIELD]?.value,
        onSelect: (value) => onChangeData(value, PURIFICATION_FIELD, true),
        moreInfoLink: PURIFICATION_LINK,
      }}
    />
    <Visible when={getCountryCode() !== COUNTRY_CODE_JAPAN}>
      <DataSelector
        {...{
          title: messages.buffer,
          config: bufferConfig,
          selectedValue: formData[BUFFER_FIELD]?.value,
          onSelect: (value) => onChangeData(value, BUFFER_FIELD, true),
          moreInfoLink: BUFFER_LINK,
        }}
      />
    </Visible>
    <Visible when={getCountryCode() !== COUNTRY_CODE_JAPAN &&
     !SECOND_PRIORITY_COUNTRIES.includes(getCountryCode())}
    >
      <DataSelector
        {...{
          title: messages.qualityTesting,
          config: qualityTestingConfig,
          selectedValue: formData[QUALITY_TESTING_FIELD]?.value,
          onSelect: (value) => onChangeData(value, QUALITY_TESTING_FIELD, true),
        }}
      />
    </Visible>
    <DataSelector
      {...{
        title: messages.shippingFormat,
        config: shippingFormatConfig,
        selectedValue: formData[SHIPPING_FORMAT_FIELD]?.value,
        onSelect: (value) => onChangeData(value, SHIPPING_FORMAT_FIELD, true),
      }}
    />
  </div>
);

PlateSizeAndDetailsComponent.propTypes = {
  formData: PropTypes.object.isRequired,
  onChangeData: PropTypes.func.isRequired,
  plateSizeConfig: PropTypes.array.isRequired,
  wellVolumeConfig: PropTypes.array.isRequired,
  scaleConfig: PropTypes.array.isRequired,
  purificationConfig: PropTypes.array.isRequired,
  bufferConfig: PropTypes.array.isRequired,
  qualityTestingConfig: PropTypes.array.isRequired,
  shippingFormatConfig: PropTypes.array.isRequired
};

export default withDnaData(PlateSizeAndDetailsComponent);
